<template>
  <div>
    <template v-if="loading">
      <v-progress-linear :indeterminate="true"></v-progress-linear>
    </template>

    <template v-else>
      <div class="title-course">
        <v-row>
          <v-col cols="12" sm="12" md="9">
            <h2>{{ course.title }}</h2>
          </v-col>
          <v-col cols="12" sm="12" md="3">
              <span class="progresso-title">
                <div class="progresso-title-barra">
                  <div class="progresso-title-barra-valor" :style="`width:${course.percentage}%`"></div>
                </div>
                <p>{{ course.percentage }}% concluído</p>
              </span>
          </v-col>
        </v-row>
      </div>

      <div class="menu-conteudo" :class="mobileListMenu ? 'active' : ''">
        <p @click="mobileListMenu = !mobileListMenu">
          <template v-if="mobileListMenu">
            <v-icon>close</v-icon>
          </template>
          <template v-else>Lista de conteúdo</template>
        </p>
      </div>

      <div class="content-course">
        <!-- {{ course }} -->
        <v-row>
          <v-col cols="12" sm="12" v-if="!course.contents.length && !course.modules.length">
            <!-- quando nao tiver contents cadastrados -->
            <div class="select-video">
              <v-alert color="blue" type="info" class="mt-3 mb-3">
                Este curso ainda não possuí nenhum conteúdo cadastrado
              </v-alert>
            </div>
          </v-col>

          <v-col cols="12" sm="12" md="9" style="padding:0;">

            <!-- conteudo de texto -->
            <div v-if="contentSelected.type === 2" class="content-text">
              <span>
                <h4 class="title-select">{{ contentSelected.title }}</h4>
                <div ref="contentText" v-observe-visibility="contentTextVisible"
                     v-html="contentSelected.description"></div>
              </span>
            </div>

            <!-- conteudo de video -->
            <div class="content-video" :style="`display: ${ contentSelected.type === 1 && contentSelected.vimeoId ? 'block' : 'none' };`">
              <!-- <h4 class="title-select">{{ contentSelected.title }}</h4> -->

              <!-- <vue-vimeo-player class="video-container" v-if="showPlayer"
                                ref="player" @play="play" @timeupdate="timeupdate" @pause="pause"
                                @ready="onReady" @stop="stop" @ended="ended" @error="error" @loaded="loaded"
                                :video-id="contentSelected.vimeoId">
              </vue-vimeo-player> -->

              <vue-plyr
                  ref="player"
                  :options="options"
                  v-if="showPlayer"
              >
                <video
                    controls
                    playsinline
                    @play="play" @timeupdate="timeupdate" @pause="pause"
                    @ready="onReady" @stop="stop" @ended="ended" @error="error" @loaded="loaded"
                >
                  <source
                      size="720"
                      :src="`${ streamUrl }${ contentSelected.vimeoId }`"
                      type="video/mp4"
                  />
                </video>
              </vue-plyr>

              <v-col cols="12" sm="12" v-if="playerReady && contentSelected.type === 1">
                <div class="video-summary" v-if="contentSelected.description">
                  <h5>Descrição do vídeo</h5>
                  <p>{{ contentSelected.description }}</p>
                </div>
              </v-col>
            </div>

            <div class="summary-course">
              <h3>Sobre o curso</h3>
              <p>{{ course.description }}</p>

              <div class="divisor"></div>

              <div class="summary-course-horas">
                <span><p>Total de aulas: {{ totalContent }} {{ totalContent > 1 ? 'aulas' : 'aula' }}</p></span>
                <span><p>Carga horária: {{ course.workload }} {{ course.workload > 1 ? 'horas' : 'hora' }}</p></span>
              </div>

              <div v-if="course.quiz">
                <div class="divisor"></div>

                <h3 class="certificado">Certificado</h3>
                <p>Certificado disponível ao término do curso</p>
              </div>
            </div>
          </v-col>

          <v-col cols="12" sm="12" md="3" class="modules-panel"
                 :class="[contentSelected.type === 1 && !contentSelected.vimeoId ? 'offset-md9' : '', mobileListMenu ? 'active':'']">
            <v-expansion-panels v-if="course.modules.length" v-model="panel">
              <v-expansion-panel v-for="(module, $index) in modulesToShow" :key="$index">
                <v-expansion-panel-header>
                  <h3>
                    Módulo {{ $index + 1 }}: {{ module.title }}
                    <p>{{ module.totalConcluded }} / {{ module.contents.length }} | {{
                        module.totalDuration | timeVideo
                      }}</p>
                  </h3>
                </v-expansion-panel-header>

                <!-- <v-icon v-if="module.seen" color="green lighten-1">check_circle</v-icon> -->
                <v-expansion-panel-content>
                  <content-list v-if="module.contents.length" :contents="module.contents" @selectContent="selectContent"
                                :contentActiveId="contentSelected._id"></content-list>
                  <v-card class="quiz-course mt-0" v-if="module.quiz">
                    <h4>Quiz do módulo</h4>
                    <v-card-text>
                      <v-btn @click="openQuizModule(module.quiz._id)">
                        Iniciar quiz
                        <font-awesome-icon class="ml-2" :icon="['fas', 'caret-right']"/>
                      </v-btn>

                    </v-card-text>
                  </v-card>
                  <!-- <div class="quiz-module" v-if="quizModule">
                    <h4>Quiz do Módulo</h4>
                    <v-btn>Lorem ipsum <font-awesome-icon class="ml-2" :icon="['fas', 'caret-right']"/></v-btn>
                  </div> -->
                </v-expansion-panel-content>


              </v-expansion-panel>
            </v-expansion-panels>

            <content-list v-if="course.contents.length" :contents="course.contents" @selectContent="selectContent"
                          :contentActiveId="contentSelected._id"></content-list>

            <v-card class="quiz-course" v-if="quizId && !course.concluded">
              <h4>Quiz do Curso</h4>
              <v-card-text>
                <!-- <v-btn :to="{name: 'quiz-show', params: {quiz_id: quizId}}">
                  Iniciar quiz
                  <font-awesome-icon class="ml-2" :icon="['fas', 'caret-right']"/>
                </v-btn> -->

                <v-btn @click="beforeQuiz = true">
                  Iniciar quiz
                  <font-awesome-icon class="ml-2" :icon="['fas', 'caret-right']"/>
                </v-btn>

              </v-card-text>
            </v-card>

            <v-card class="quiz-course" v-if="certifiedId">
              <h4>Curso concluído</h4>
              <v-card-text>
                <v-btn @click="downloadCertified" :loading="downloading" :disabled="downloading">
                  Baixe o certificado
                  <font-awesome-icon class="ml-2" :icon="['fas', 'caret-right']"/>
                </v-btn>
              </v-card-text>
            </v-card>

            <v-card class="nota-curso">
              <h4>Dê uma nota para o curso</h4>
              <v-card-text class="d-flex">
                <v-rating
                    v-model="rating"
                    background-color="orange lighten-3"
                    class="float-left"
                    color="orange"
                    large
                ></v-rating>
                <v-progress-circular
                    class="float-right mt-4 ml-3"
                    v-if="sendingRating"
                    indeterminate
                    :size="20"
                    :width="2"
                    color="success"
                ></v-progress-circular>
              </v-card-text>
            </v-card>

            <v-dialog
                v-model="beforeQuiz"
                max-width="800"
            >
              <v-card class="before-quiz">
                <v-card-header class="text-center">
                  <h4>Vamos lá!</h4>
                  <p>Você esta próximo de receber o certificado de conclusão do curso.</p>
                  <p>Separe um tempo e um local tranquilo para responder as perguntas do quiz.</p>
                </v-card-header>
                <v-card-text class="text-center pt-3 pb-0">
                  <h5>Alguns pontos importantes:</h5>
                  <ul>
                    <li>O quiz tem duração de 30 minutos</li>
                    <li>Você terá 3 oportunidades de realizar o quiz</li>
                    <li>Caso não for aprovado até a 3ª vez, será necessário assistir as aulas novamente para uma nova
                      oportunidade de responder o quiz
                    </li>
                  </ul>

                  <v-btn :to="{name: 'quiz-show', params: {quiz_id: quizId}}">
                    Iniciar quiz
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-dialog>
            <v-dialog
                v-model="beforeQuizModule"
                max-width="800"
            >
              <v-card class="before-quiz">
                <v-card-header class="text-center">
                  <h4>Vamos lá!</h4>
                  <p>Você esta próximo de receber o certificado de conclusão do mídulo.</p>
                  <p>Separe um tempo e um local tranquilo para responder as perguntas do quiz.</p>
                </v-card-header>
                <v-card-text class="text-center pt-3 pb-0">
                  <h5>Alguns pontos importantes:</h5>
                  <ul>
                    <li>O quiz tem duração de 30 minutos</li>
                    <li>Você terá 3 oportunidades de realizar o quiz</li>
                    <li>Caso não for aprovado até a 3ª vez, será necessário assistir as aulas do módulo novamente para
                      uma nova
                      oportunidade de responder o quiz
                    </li>
                  </ul>

                  <v-btn :to="{name: 'quiz-show', params: {quiz_id: quizId}}">
                    Iniciar quiz
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-dialog>

          </v-col>
        </v-row>
      </div>
    </template>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import slugfy from 'slugify'
import { faCaretRight, faFileAlt } from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'
import { ObserveVisibility } from 'vue-observe-visibility'
import EventBus from '@/eventBus'
import ContentList from '@/components/User/ContentList'

library.add(faCaretRight, faFileAlt)

export default {
  name: 'Courses',
  data () {
    return {
      streamUrl: process.env.VUE_APP_STREAM_URL,
      options: {
        invertTime: false,
        controls: ['play-large', 'play', 'progress', 'current-time', 'duration', 'mute', 'volume', 'pip', 'airplay', 'fullscreen']
      },
      player: null,
      rating: 0,
      sendingRating: false,
      mobileListMenu: false,
      loading: true,
      downloading: false,
      certifiedId: null,
      showPlayer: false,
      totalContent: 0,
      heightText: 0,
      panel: 0,
      contentSelected: {
        time: 0,
        percentage: 0
      },
      percentageTextView: 0,
      counter: '',
      videoTotalTimeSeen: 0,
      moduleText: null,
      quizId: null,
      quizModule: {},
      quizCourse: [],
      playerReady: false,
      startTime: 0,
      course: {
        title: '',
        modules: [],
        contents: [],
        concluded: false
      },
      contentRegistered: false,
      contentView: true,
      beforeQuiz: false,
      beforeQuizModule: false
    }
  },
  components: { ContentList },
  directives: {
    'observe-visibility': ObserveVisibility
  },
  computed: {
    ...mapGetters(['getContent', 'getUser', 'getContentSecondsStopped']),
    modulesToShow: function () {
      if (!this.course.modules || !this.course.modules.length) {
        return []
      }

      return this.course.modules.filter(module => {
        return module.contents && module.contents.length
      }).map(module => {
        module.totalConcluded = module.contents.reduce((total, content) => {
          if (content.percentage >= 75) {
            total++
          }

          return total
        }, 0)

        module.totalDuration = module.contents.reduce((total, content) => {
          if (content.duration) {
            total += parseInt(content.duration)
          }

          return total
        }, 0)

        return module
      })
    }
  },
  watch: {
    rating (points) {
      this.sendRating(points)
    },
    contentSelected (val) {
      if (val && val.type === 2) {
        if (this.$refs.contentText) {
          setTimeout(() => {
            this.heightText = this.$refs.contentText.offsetHeight
          }, 100)
        }
      }
    },
    heightText (val) {
      if (val) {
        if (window.innerHeight === document.documentElement.offsetHeight) {
          // this.percentageTextView = 100
        }
      }
    },
    percentageTextView (val) {
      if (val === 100 && this.contentSelected.percentage < 100) {
        this.logContent(0, this.contentSelected._id)
      }
    },
    modulesToShow (val) {
      if (!val || !val.length) {
        return false
      }

      for (let i = 0; i < val.length; i++) {
        if (val[i].contents && val[i].contents.length) {
          for (const content of val[i].contents) {
            if (this.contentSelected && this.contentSelected._id === content._id) {
              this.panel = i
            }
          }
        }
      }
    }
  },
  methods: {
    ...mapActions(['setContent', 'setContentSecondsStopped', 'deleteContentSecondsStopped', 'deleteContent']),
    onReady (player) {
      if (this.contentSelected && this.contentSelected.time) {
        player.target.currentTime = this.contentSelected.time
      }

      this.playerReady = true
      this.showPlayer = true
    },

    openQuizModule (quizId) {
      this.quizId = quizId
      this.beforeQuizModule = true
    },

    downloadCertified () {
      this.downloading = true

      this.axios({
        url: `/user/certificate/file/${this.certifiedId}`,
        method: 'GET',
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', slugfy(this.course.title, '_') + '.pdf')
        document.body.appendChild(link)
        link.click()
      }).catch(err => {
        console.error(err)

        this.$swal('Ops', 'Erro ao baixar o certificado', 'error')
      }).finally(() => {
        this.downloading = false
      })
    },
    contentTextVisible (isVisible, entry) {
      if (isVisible) {
        this.heightText = entry.target.offsetHeight
      }
    },

    startCounter () {
      this.counter = setInterval(() => {
        this.videoTotalTimeSeen++
      }, 1000)
    },

    // stopCounter () {
    //   clearInterval(this.counter)
    // },

    sendRating (points) {
      this.sendingRating = true
      this.axios.post('/user/course-satisfaction', { courseId: this.course._id, points }).then(({ data }) => {
        if (!data.success) {
          this.$swal('Ops', (data.message || 'Erro ao enviar'), 'error')
        }
      }).catch(err => {
        console.error(err)

        this.$swal('Ops', 'Erro ao enviar', 'error')
      }).finally(() => {
        this.sendingRating = false
      })
    },

    error (err) {
      this.$swal('Ops', 'Vídeo não pode ser carregado', 'error')
      this.showPlayer = false
      console.error(`VUE ERROR: ${err.message}`)
    },

    play (e) {
      if (e) {
        this.startCounter()
      }

      // if (e) {
      //   this.logContent({ start: e.seconds })
      // }

      this.$refs.player.player.play()
    },
    pause (e) {
      // this.stopCounter()
      // console.log('pause', e)

      clearInterval(this.counter)

      this.logContent(this.videoTotalTimeSeen)
      this.setContent(this.contentSelected)

      this.videoTotalTimeSeen = 1

      // this.logContent({ stop: e.seconds })

      this.$refs.player.player.pause()
      // this.$refs.player.pause()
    },
    ended (e) {
      if (e.target.currentTime) {
        this.logContent(e.target.currentTime)
      }
      this.deleteContent()

      setTimeout(() => {
        location.reload()
      }, 0)
    },
    loaded (e) {
      // console.log('loaded', e)
    },
    timeupdate (event) {
      this.contentSelected.time = event.target.currentTime.toFixed(2)

      /**
       * ALTERADO PARA SALVAR O TIME DO VIDEO QUE O CARA PAROU, APENAS QUANDO TEM AÇÕES DE LOG
       */
      // this.setContent(this.contentSelected)
    },
    stop (e) {
      this.$refs.player.player.stop()
    },

    // scroll () {
    //   window.onscroll = () => {
    //     let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight === document.documentElement.offsetHeight
    //     if (bottomOfWindow) {
    //       this.percentageTextView = 100 // replace it with your code
    //     }
    //   }
    // },
    selectContent (content) {
      // if (this.showPlayer) {
      //   this.$refs.player.player.destroy()
      //   this.$refs.player = this.VuePlyr
      // }
      if (this.showPlayer) {
        location.reload()
      }

      this.showPlayer = false
      // console.log('this.$refs.player', this.$refs.player)

      // if (this.showPlayer) {
      //
      //   this.showPlayer = true
      //   console.log('destroy')
      //   // this.$refs.player.player.destroy()
      //
      //   // this.$refs.player = this.ply?
      //
      //
      // }

      content.time = 0

      this.percentageTextView = 0

      this.moduleText = null

      if (content.type === 1) {
        this.showPlayer = true
      }

      if (content.type === 2) {
        window.onscroll = () => {
          if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
            this.percentageTextView = 100
          }
        }
      }

      this.setContent(content)

      this.contentSelected = { ...content }

      if (this.contentSelected.type === 1 && this.contentSelected.vimeoId && this.$refs.player) {
        this.$refs.player.player.source = {
          type: 'video',
          sources: [
            {
              src: `${this.streamUrl}${this.contentSelected.vimeoId}`,
              type: 'video/mp4',
              size: 720,
            }
          ]
        }
      }
    },
    // rulesShowQuiz () {
    //   if (this.course.quiz) {
    //     let totalContent = 0,
    //       totalContentOK = 0
    //
    //     if (this.course.modules.length) {
    //       for (let i = 0; i < this.course.modules.length; i++) {
    //         for (let k = 0; k < this.course.modules[i].contents.length; k++) {
    //           totalContent++
    //           if (this.course.modules[i].contents[k].percentage >= 75) {
    //             totalContentOK++
    //           }
    //         }
    //       }
    //     }
    //
    //     if (this.course.contents.length) {
    //       for (let i = 0; i < this.course.contents.length; i++) {
    //         totalContent++
    //         if (this.course.contents[i].percentage >= 75) {
    //           totalContentOK++
    //         }
    //       }
    //     }
    //
    //     if (totalContentOK === totalContent) {
    //       this.showQuiz = true
    //     }
    //   }
    // },
    logContent (seconds, contentId) {
      contentId = (contentId ? contentId : this.contentSelected._id)

      this.axios.post('/user/log/', { content_id: contentId, seconds }).then(response => {
        if (response.data.success) {
          if (response.data.quizId) {
            this.quizId = response.data.quizId
          }

          if (response.data.certificateId) {
            this.certifiedId = response.data.certificateId
          }

          if (this.course.modules.length) {
            for (let i = 0; i < this.course.modules.length; i++) {
              for (let k = 0; k < this.course.modules[i].contents.length; k++) {
                if (String(this.course.modules[i].contents[k]._id) === String(this.contentSelected._id)) {
                  this.course.modules[i].contents[k].percentage = response.data.log.percentage
                }
              }
            }

            if (response.data.moduleId && response.data.quizId) {
              const module = this.course.modules.find(module => module._id === response.data.moduleId)

              module.quiz = {
                _id: response.data.quizId
              }
            }
          }

          for (let i = 0; i < this.course.contents.length; i++) {
            if (String(this.course.contents[i]._id) === String(this.contentSelected._id)) {
              this.course.contents[i].percentage = response.data.log.percentage
            }
          }
        } else {
          this.$swal('Ops', response.data.message, 'error')
        }
      }).catch(err => {
        console.error(err)

        this.$swal('Ops', 'Houve um erro ao gravar o log', 'error')
      })
    },
    getCourse () {
      this.axios.get(`/user/course/${this.$route.params.course_id}`).then(response => {
        if (!response.data.success) {
          this.$router.push({ name: 'course-list' })

          return false
        }

        this.course = response.data.course

        if (response.data.course.quiz) {
          this.quizId = response.data.course.quiz._id
        }

        if (response.data.course.certifiedId) {
          this.certifiedId = response.data.course.certifiedId
        }

        if (response.data.course.courseSatisfaction) {
          this.rating = response.data.course.courseSatisfaction.points
        }

        if (response.data.course.contents && response.data.course.contents.length) {
          this.totalContent += response.data.course.contents.length
        }

        if (response.data.course.modules && response.data.course.modules.length) {
          const modules = response.data.course.modules

          for (const module of modules) {
            if (module.contents && module.contents.length) {
              this.totalContent += module.contents.length
            }
          }

          this.openPanel(response.data.course.modules)
        }

        this.loading = false
      })
    },
    openPanel (modules) {
      if (this.contentSelected.module) {
        let index = modules.findIndex(m => {
          return m._id === this.contentSelected.module || m._id === this.contentSelected.module._id
        })

        if (index !== -1) {
          this.panel = index
        }
      }
    },
  },
  created () {
    // this.$refs.player = this.VuePlyr

    // this.scroll()
    let contentSelected = this.getContent

    if (contentSelected) {
      // this.contentSelected = contentSelected
      this.selectContent(contentSelected)
    }

    // if (this.contentSelected && this.contentSelected.time > 0) {
    //   window.addEventListener('beforeunload', event => {
    //     event.preventDefault()
    //     event.stopPropagation()

    //     this.setContentSecondsStopped(this.contentSelected.time)
    //   })
    // }

    // if (this.getContentSecondsStopped) {
    //   // this.logVideo({ stop: this.getContentSecondsStopped })

    //   this.deleteContentSecondsStopped()
    // }

    this.getCourse()
  },
  mounted () {
    EventBus.$emit('DRAWER_MENU', false)
  }

}
</script>
